import React, {useState, useEffect} from 'react';
import {Accordion, AccordionSummary, AccordionDetails} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {EmployeeErrorDetailsDto} from 'Enrollment/api';

type ErrorDisplayAccordionProps = {
  expanded: boolean;
  employeeWithError: EmployeeErrorDetailsDto[];
  errorType: string;
};

const ErrorDisplayAccordion = ({expanded, errorType, employeeWithError}: ErrorDisplayAccordionProps) => {
  const [expandAccordion, setExpandAccordion] = useState<boolean>(expanded);

  useEffect(() => {
    setExpandAccordion(expanded);
  }, [expanded]);

  const handleChange = () => {
    setExpandAccordion(!expandAccordion);
  };
  return (
    <Accordion
      className="enrollment-file-error-accordion"
      key={`${errorType}__enrollment-file-error-accordion`}
      expanded={expandAccordion}
      onChange={handleChange}
    >
      <AccordionSummary className="enrollment-file-error-accordion__summary" expandIcon={<ExpandMoreIcon />}>
        <div className="enrollment-file-error-accordion__summary--field">
          <span className="title">Error Name:</span>
          <span className="value">{errorType}</span>
        </div>
        <div className="enrollment-file-error-accordion__summary--field">
          <span className="title">Count:</span>
          <span className="value">{employeeWithError.length}</span>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        {employeeWithError.map((employee, index) => {
          return (
            <div
              className="enrollment-file-error-accordion__details"
              key={`enrollment-file-error-accordion__details-${employee!.id!}-${index}`}
            >
              <div className="enrollment-file-error-accordion__details--field">
                <span className="title">First Name:</span>
                <span className="value">{employee.firstName}</span>
              </div>
              <div className="enrollment-file-error-accordion__details--field">
                <span className="title">Last Name:</span>
                <span className="value">{employee.lastName}</span>
              </div>
            </div>
          );
        })}
      </AccordionDetails>
    </Accordion>
  );
};

export default ErrorDisplayAccordion;
